import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AccountsService } from '../../services/identity/accounts.service';

@Injectable({ providedIn: 'root' })
export class AuthProjectsRedirectGuard implements CanActivate {
    constructor(private readonly accountsService: AccountsService, private readonly router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const projectId = route.params['id'];
        const isAuthenticated = this.isAuthenticated();
        const isPublicProject = state.url.startsWith('/projects/public');

        if (!isAuthenticated && !isPublicProject) {
            this.redirectToPublicProject(projectId);
            return false;
        }

        return true;
    }

    private isAuthenticated(): boolean {
        return this.accountsService.isAuthenticated;
    }

    private redirectToPrivateProject(projectId: string): void {
        const targetUrl = `/projects${projectId ? '/' + projectId : ''}`;
        this.router.navigateByUrl(targetUrl);
    }

    private redirectToPublicProject(projectId: string): void {
        const targetUrl = `/projects/public${projectId ? '/' + projectId : ''}`;
        this.router.navigateByUrl(targetUrl);
    }
}
